import type { DeepRequired } from '../fixtures.types'

const kbaSubmissionResponse: DeepRequired<KbaSubmissionResponse> = {
  __typename: 'KbaSubmissionResponse',
  attempts_remaining: 0,
  decision: 'PASS',
  second_questionnaire: null,
}

export default kbaSubmissionResponse
